import { getNextItemIndex } from '@/utils/array';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import { getActiveChartTypeOption } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";

const WidgetEditFormChartType = _ref => {
  let {
    label = 'Type',
    chartType,
    defaultChartType,
    options = [],
    openButtonVariant,
    onChange
  } = _ref;
  const {
    currentChartTypeOption,
    currentChartTypeOptionIdx
  } = getActiveChartTypeOption(chartType || defaultChartType, options);
  return /*#__PURE__*/_jsx(RevealPill, {
    label: label,
    disableOpen: true,
    activeState: currentChartTypeOption === null || currentChartTypeOption === void 0 ? void 0 : currentChartTypeOption.icon,
    openButtonVariant: openButtonVariant,
    onOpenChange: () => {
      const nextOptionIdx = getNextItemIndex(currentChartTypeOptionIdx, options.length);
      onChange(options[nextOptionIdx].value);
    }
  });
};

export default WidgetEditFormChartType;